import { render, staticRenderFns } from "./ServicesByTagsSelect.vue?vue&type=template&id=dab542d6&scoped=true"
import script from "./ServicesByTagsSelect.vue?vue&type=script&lang=js"
export * from "./ServicesByTagsSelect.vue?vue&type=script&lang=js"
import style0 from "./ServicesByTagsSelect.vue?vue&type=style&index=0&id=dab542d6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab542d6",
  null
  
)

export default component.exports